import React from "react";
import { ASSETS } from "../lib/assets";

/**
 * Flying pig — hand-drawn artwork, transparent PNG.
 * Works on both light and dark surfaces.
 */
export const FlyingPigSVG = ({ className = "" }) => (
  <img
    src={ASSETS.flyingPigArt}
    alt=""
    aria-hidden="true"
    draggable="false"
    loading="lazy"
    className={`h-auto max-w-full select-none pointer-events-none object-contain ${className}`}
  />
);

export default FlyingPigSVG;
